import { StyleSheet } from 'aphrodite';
import { AppTheme, AppStyles } from '../../../styles/AppTheme';

export const SEStyles = StyleSheet.create({
  container: {
    // background: 'white',
    height: '100%',
    borderRadius: AppTheme.borderRadius,
  },
  content: {
    padding: AppTheme.pagePadding * 4,
  },
  heading: {
    borderBottom: '1px solid lightgray',
  },
  headingContent: {
    padding: AppTheme.pagePadding * 4,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  editButton: {
    color: AppTheme.primaryColor,
    backgroundColor: 'none',
    fontWeight: 600,
    padding: 0,
    fontSize: 16,
    textTransform: 'none',
    minWidth: 'auto',
    ':hover': {
      background: 'none',
      backgroundColor: 'none',
    }
  },
  stepFormTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    margin: 0,
    textTransform: 'capitalize'
  },
  label: {
    fontSize: 14,
    color: 'grey',
    marginBottom: 2,
    marginTop: 0
  },
  value: {
    margin: 0,
    fontSize: 14,
    color: '#4a4a4a',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  valueDisplayMultiline: {
    whiteSpace: 'normal'
  },
  actionIcon: {
    color: AppTheme.primaryColor
  },
  imageContainer: {
    width: 'fit-content',
    height: 50,
    border: '1px solid #E2EAFC',
    borderRadius: 8,
    overflow: 'hidden'
  },
  imageContent: {
    maxWidth: '100%',
    maxHeight: '100%',
  },
  link: {
    color: AppTheme.primaryColor,
    textDecoration: 'none',
    borderBottom: '0.5px solid ' + AppTheme.primaryColor,
    width: 'fit-content'
  },
  buttonText: {
    color: AppTheme.primaryColor,
    fontWeight: 600
  },
  labelContainer: {
    paddingBottom: 20
  },
})



// WEBPACK FOOTER //
// ./src/common/components/SubEntity/SEStyles.js